import * as React from "react";

import styled from "styled-components";
import { useTranslation } from "react-i18next";

import head_congress from "../../../../../assets/pictures/use_cases/ee_1.png";
import benefits from "../../../../../assets/pictures/use_cases/ee_2.png";

const HeroStyled = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const HeroPresentation = styled.section`
  width: 1110px;
  height: calc(100vh - 233px);
  display: flex;
  align-items: center;
  .info {
    flex: 0 0 45%;
    margin-right: 6em;
    h1 {
      margin: 0;
      font-size: 2.8em;
      margin-bottom: 0.5em;
    }
    p {
      margin: 0;
      margin-bottom: 1em;
    }
  }
`;

const HeroList = styled.section`
  width: 1110px;
  height: calc(100vh - 233px);
  display: flex;
  align-items: center;
  justify-content: center;
  h1 {
    margin-top: 0;
  }
  .hl-container {
    display: flex;
    justify-content: space-around;
    width: 1100px;
    position: relative;
    .item-1 {
      bottom: 15%;
      text-align: right;
      left: -20%;
    }
    .item-2 {
      top: 0%;
      right: -20%;
    }
    .item-3 {
      bottom: 0%;
      right: -20%;
    }
    .hl-item {
      display: flex;
      flex-direction: column;
      flex: 1 0 30%;
      position: absolute;
      width: 535px;
      h1 {
        font-size: 1.3em;
        margin-bottom: 1em;
      }
      p {
        margin-top: 0;
        font-size: 1em;
      }
    }
  }
`;
function Hero() {
  const { t } = useTranslation(["use_cases"]);

  return (
    <HeroStyled>
      <HeroPresentation>
        <div className="info">
          <h1>Employee Engagement</h1>
          <p>
            Haz que tus empleados se sientan cerca y parte de la compañía.
            Vuelve a tus colaboradores voceros de su empresa, motívalos e
            ¡interactúa con ellos en tiempo real!
          </p>
        </div>
        <div>
          <img src={head_congress} width="550" alt="" />
        </div>
      </HeroPresentation>
      <HeroList>
        <div className="hl-container">
          <img src={benefits} alt="" width="450" />
          <div className="hl-item item-1">
            <div>
              <img src="" alt="" />
            </div>
            <h1>Personalizable</h1>
            <p>
              Cuida la identidad visual de tu compañía y dales herramientas para
              interactuar. Los chistes locales y esa misión que quieren imprimir
              son clave para Neerme.
            </p>
          </div>
          <div className="hl-item item-2">
            <div>
              <img src="" alt="" />
            </div>
            <h1>Interacción</h1>
            <p>
              Crea eventos innovadores que comprometan a tus colaboradores con
              la empresa, usa todas nuestras herramientas de interacción y
              brandeo de la plataforma.
            </p>
          </div>
          <div className="hl-item item-3">
            <div>
              <img src="" alt="" />
            </div>
            <h1>Métricas</h1>
            <p>
              Obtén analíticos de tu colaborador, recibe feedback de la dinámica
              y crea estadísticas para justificar el proyecto.
            </p>
          </div>
        </div>
      </HeroList>
    </HeroStyled>
    // <HeroStyled>
    //   <HeroPresentation>
    //     <div className="info">
    //       <h1>{t("use_congress.title")}</h1>
    //       <p>{t("use_congress.desc_2")}</p>
    //     </div>
    //     <div>
    //       <img src={head_congress} width="700" alt="" />
    //     </div>
    //   </HeroPresentation>
    //   <HeroList>
    //     <div className="hl-container">
    //       <img src={benefits} alt="" width="450" />
    //       <div className="hl-item item-1">
    //         <div>
    //           <img src="" alt="" />
    //         </div>
    //         <h1>{t("use_congress.list_item_1_title")}</h1>
    //         <p>{t("use_congress.list_item_1_desc")}</p>
    //       </div>
    //       <div className="hl-item item-2">
    //         <div>
    //           <img src="" alt="" />
    //         </div>
    //         <h1>{t("use_congress.list_item_2_title")}</h1>
    //         <p>{t("use_congress.list_item_2_desc")}</p>
    //       </div>
    //       <div className="hl-item item-3">
    //         <div>
    //           <img src="" alt="" />
    //         </div>
    //         <h1>{t("use_congress.list_item_3_title")}</h1>
    //         <p>{t("use_congress.list_item_3_desc")}</p>
    //       </div>
    //     </div>
    //   </HeroList>
    // </HeroStyled>
  );
}

export default Hero;
